import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import YourFinalApproachStrategy from "./sections/YourFinalApproachStrategy";
import TheFourFlightConditions from "./sections/TheFourFlightConditions";
import OperationalLogistics3Steps from "./sections/OperationalLogistics3Steps";
import WhyThisIsPilotToPilot from "./sections/WhyThisIsPilotToPilot";
import CurrentOperationalArea from "./sections/CurrentOperationalArea";
import SecureYourArrival from "./sections/SecureYourArrival";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <YourFinalApproachStrategy />
      <TheFourFlightConditions />
      <OperationalLogistics3Steps />
      <WhyThisIsPilotToPilot />
      <CurrentOperationalArea />
      <SecureYourArrival />
      <Footer />
    </div>;
}